import { render } from "./FloatingHomeButton.vue?vue&type=template&id=31faf8b1&scoped=true"
import script from "./FloatingHomeButton.vue?vue&type=script&lang=js"
export * from "./FloatingHomeButton.vue?vue&type=script&lang=js"

import "./FloatingHomeButton.vue?vue&type=style&index=0&id=31faf8b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31faf8b1"]])

export default __exports__